import { useQuery } from '@tanstack/react-query';
import { recipeFavouriteRequests } from '@/lib/api/requests/recipe-favourites';
import type { PaginationParams } from '@/types/common';
import { favouriteKeys } from './keys';

export function useRecipeFavourites(params?: PaginationParams, enabled = true) {
  return useQuery({
    queryKey: favouriteKeys.list(params),
    queryFn: () => recipeFavouriteRequests.list(params),
    enabled,
    placeholderData: (prev) => prev,
  });
}

export function useRecipeFavouriteStatus(recipeId: number, enabled = true) {
  return useQuery({
    queryKey: favouriteKeys.status(recipeId),
    queryFn: () => recipeFavouriteRequests.status(recipeId),
    enabled: !!recipeId && enabled,
  });
}
